// import React from "react";
// import { useDispatch, useSelector } from "react-redux";
// import WelcomeList from "./WelcomeList";
// import PrimaryButton from "../PrimaryButton";
// import { createConnectedAccount } from "../../../services/fundraiserService";
// import { ReactComponent as DollarIcon } from "../../../Assets/Icons/dollarIcon.svg";
// import { ReactComponent as TimeIcon } from "../../../Assets/Icons/timeIcon.svg";
// import { ReactComponent as ListIcon } from "../../../Assets/Icons/listIcon.svg";
// import { useNavigate } from "react-router-dom";

// const MerchantWelcome = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const handleSubmit = async () => {
//     // const linkPromise = await dispatch(createConnectedAccount()).unwrap();
//     // window.location.href = linkPromise?.data;
//     navigate("/merchant/welcome-offer");
//   };

//   const welcomeList = [
//     {
//       heading: "How long does it take?",
//       text: "Building a new offer typically takes 30 minutes. After you submit your offer, we’ll review it within 1 business day.",
//       icon: <TimeIcon />,
//     },
//     {
//       heading: "What does it cost?",
//       text: "There’s zero upfront cost to build an offer.",
//       icon: <DollarIcon />,
//     },
//     {
//       heading: "Do I need anything before I get started?",
//       text: "Have the following documents ready, you’ll need this information to complete the next steps: Photos of your business and services or goods",
//       icon: <ListIcon />,
//     },
//   ];

//   return (
//     <div className="sm:w-[80%] md:w-[70%] lg:w-[60%] py-20">
//       <p className="font-poppins font-[500] text-[28px] text-center text-[#303030]">
//         Welcome to Swoodle Merchant!
//       </p>
//       <p className="font-poppins font-[400] text-[14px] text-center text-[#767676]">
//         Select get started to build your offer.
//       </p>
//       <p className="font-poppins font-[500] text-[18px] text-start text-[#303030] mt-10">
//         Meet Offer Builder
//       </p>
//       <p className="font-poppins font-[400] text-[14px] text-start text-[#767676] mt-2">
//         Launch your swoodle offer in no time using offer builder. Just tell us
//         what services your business offers and we’ll help you build a offer you
//         have full control over, customize your deal’s pricing, discount,
//         marketing copy photos, and more using offer builder’s data driven
//         guidance.
//       </p>
//       <div className="flex flex-col gap-5 mt-10">
//         {welcomeList?.map((item) => (
//           <WelcomeList
//             heading={item?.heading}
//             text={item?.text}
//             icon={item?.icon}
//           />
//         ))}
//       </div>
//       <div className="w-full text-end mt-20">
//         <PrimaryButton
//           className={
//             "w-[20%] font-montserrat text-[14px] text-center font-[500] h-[45px] rounded-[5px]"
//           }
//           label="Get Started"
//           onClick={handleSubmit}
//         />
//       </div>
//     </div>
//   );
// };

// export default MerchantWelcome;

// COMING SOON SCREEN COMMENTED OUT - MERCHANTS NOW GO TO DASHBOARD
// import React, { useEffect, useState } from "react";
// import Lottie from "react-lottie";
// import myAnimation from "../../../animations/commingSoon.json";

// const MerchantWelcome = () => {
//   const [currentSlide, setCurrentSlide] = useState(0);

//   // Client's required messages in the correct order
//   const slides = [
//     "Thanks for Registering",
//     "We are just adding some extra features",
//     "Swoodle Campaign builder is coming soon",
//     "We will alert you once the Campaign builder is ready",
//   ];

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
//     }, 3000); // 3-second interval for each slide

//     return () => clearInterval(timer);
//   }, [slides.length]);

//   const defaultOptions = {
//     loop: true,
//     autoplay: true,
//     animationData: myAnimation,
//     rendererSettings: {
//       preserveAspectRatio: "xMidYMid slice",
//     },
//   };

//   return (
//     <div className="sm:w-[80%] md:w-[70%] lg:w-[60%] py-20">
//       <p className="font-poppins font-[500] text-[28px] text-center text-[#303030]">
//         Welcome to Swoodle Merchants!
//       </p>
//       {/* <p className="text-center font-poppins font-[500] text-[20px] text-[#303030] mt-4">
//         Extra features Coming Soon
//       </p> */}
//       <div className="flex flex-col md:flex-row w-full max-w-4xl mx-auto bg-white rounded-xl shadow-2xl overflow-hidden mt-20">
//         <div className="w-full md:w-1/2 relative h-64 md:h-auto">
//           <div>
//             <Lottie options={defaultOptions} />
//           </div>
//         </div>
//         <div className="w-full md:w-1/2 p-8 flex flex-col justify-center relative">
//           <div className="relative h-24 overflow-hidden">
//             {slides.map((slide, index) => (
//               <div
//                 key={index}
//                 className={`absolute w-full transition-all duration-500 ease-in-out text-center ${
//                   index === currentSlide
//                     ? "translate-y-0 opacity-100"
//                     : "translate-y-full opacity-0"
//                 }`}
//               >
//                 <p className="text-lg text-gray-600">{slide}</p>
//               </div>
//             ))}
//           </div>
//           {/* Dots for Slide Navigation */}
//           <div className="flex justify-center mt-6 space-x-2">
//             {slides.map((_, index) => (
//               <button
//                 key={index}
//                 onClick={() => setCurrentSlide(index)}
//                 className={`w-3 h-3 rounded-full ${
//                   index === currentSlide ? "bg-[#00ADEF]" : "bg-gray-300"
//                 }`}
//                 aria-label={`Slide ${index + 1}`}
//               />
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// TEMPORARY COMPONENT - MERCHANTS NOW GO DIRECTLY TO DASHBOARD
import React from "react";
import { useNavigate } from "react-router-dom";

const MerchantWelcome = () => {
  const navigate = useNavigate();

  // Redirect merchants directly to dashboard
  React.useEffect(() => {
    navigate("/merchant/dashboard");
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <h2 className="text-xl font-semibold text-gray-700 mb-4">Redirecting to Dashboard...</h2>
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
      </div>
    </div>
  );
};

export default MerchantWelcome;
